import React from "react";
import { useState,useEffect } from "react";
import { Helmet } from 'react-helmet';
import SalespersonSidebar from "./SalespersonSidebar";
import './classes/ViewTab.css';
import './classes/ManageScoutingReportsEdit.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';
import ManageScoutingReportsView from "./ManageScoutingReportsView";
import ScoutSidebar from "./ScoutSidebar";

const ManageScoutingReportsEdit = () =>{
    const [isLoading, setIsLoading] = useState(true);
    const [toggle, setToggle] = useState(2);
    const [errors, setErrors] = useState({});   
    const [tempImage, setTempImage] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);   
    const [uploadedImage, setUploadedImage] = useState(null); 
    const [tempFile, setTempFile] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [fileUploadError, setFileUploadError] = useState('');
    const [PreviewFields, setPreviewFields] = useState(false);
    const [viewChanges, setViewChanges] = useState(false);
    const [originalData, setOriginalData] = useState(null);
    const [formDataSnapshot, setFormDataSnapshot] = useState(null);
    const [previewData, setPreviewData] = useState(null);     
    const [userloggedinroles, setRole] = useState(null);
    const domainName = window.location.host.replace(/^https?:\/\//, '');
    const location = useLocation();
    const drupal_uid = localStorage.getItem('drupal_uid');
    const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
    var loggedin_domain = drupal_domain_url;
    if(localStorage.getItem('loggedin_domain')) {
    loggedin_domain = localStorage.getItem('loggedin_domain');
    } 
    const {rid} = useParams();
    
    const {tab} = useParams();
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;
    const [disabled, setDisabled] = useState(false);
    const [buttontext, setButtonText] = useState("Save");

    function updateToggle(id){
      setToggle(id);
  
      if(id == 1) { 
      
        navigate("/scout-report/"+rid+"/view");
      }
      if(id == 2) { 
        navigate("/scout-report/"+rid+"/edit");
      }  
    }

    useEffect(() => {
       Promise.all([
          retrieveEditScoutReport(),
          retrieveloggedinuserroles()
          ]).then(() => {
     
            setIsLoading(false);
             if(tab == "view") {
            setToggle(1);
        }
        if(tab == "edit") {
            setToggle(2);
        }
          })
        
    } ,[tab]);
 async function  retrieveloggedinuserroles() {
    try {
        setIsLoading(true);
        const response = await fetch(
      app_url+'viewprofile/getuserloggedinrolesid',
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.result === "Success") {
        
        setRole(responsedata.data.roles);
    }
      } catch (error) {
        console.error(error);
      }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
        }
    const initialFormData = {
        title: '',
        field_file_upload:'',
        field_scout_report_image:'',
        field_scout_report_sport:'',
        field_meta_title:'',
        field_meta_keywords:'',
        field_meta_description:'',
        field_delete_scout_report_image:0,
        // button_name:'Save',
    };
    const [formData, setFormData] = useState(initialFormData);
    const [selectedSport,setSelectedSport] = useState('baseball');
    const [imageUploadError, setImageUploadError] = useState('');
    const [imageRemoved, setImageRemoved] = useState(false);
    const [savedData, setSavedData] = useState(initialFormData);


  async function  retrieveEditScoutReport() {
        const response = await fetch(
        app_url+'smwwscout/retrievescoutreport?id='+rid,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )
        const responsedata = await response.json();
        if(responsedata.data.msg == "Success") {
            const updatedForm = {
                title: responsedata.data.result.title,
                field_scout_report_sport: responsedata.data.result.field_scout_report_sport,
                field_meta_title: responsedata.data.result.field_meta_title,
                field_meta_keywords: responsedata.data.result.field_meta_keywords,
                field_meta_description: responsedata.data.result.field_meta_description,
                // field_scout_report_image: responsedata.data.result.field_scout_report_image,
                field_scout_report_image:  responsedata.data.result.field_scout_report_image_details.url,
                field_file_upload: responsedata.data.result.field_scout_report_file_details?.name || '',
                id:rid
            };
            setUploadedFile(responsedata.data.result.field_scout_report_file_details);
            setUploadedImage(responsedata.data.result.field_scout_report_image_details);
            setFormData(updatedForm);
            setOriginalData(updatedForm); 

        }
    }
  const getFullFileUrl = (path) => {
    if (!path) return "";
    
    if (path.startsWith("http://") || path.startsWith("https://")) {
        return path;
    }

    // Update with actual file server path
    const baseUrl = window.location.origin;
    return `${baseUrl}/${path}`;
  };

  // const getPageTitle = () => {
  //     if (toggle === 1) {
  //         return savedData.title
  //         ? `${savedData.title}`
  //         : 'View Scout Report';
  //     } else {
  //         return savedData.title
  //         ? `Edit Scout Report ${savedData.title}`
  //         : 'Edit Scout Report';
  //     }
  // };

    const getPageTitle = () => {
      const title = originalData?.title || "";

      if (toggle === 1) {
        return title ? title : "View Scout Report";
      } else if (toggle === 2) {
        return title ? `Edit Scout Report ${title}` : "Edit Scout Report";
      }

      return "Scout Report"; // default fallback
    };

  const sportsOptions = [
      "actions sports", "basketball", "baseball", "boxing", "cricket", "extreme sports",
      "football", "golf", "hockey", "motor sports", "martial arts", "Olympic sports",
      "track and field", "rugby", "tennis", "soccer"
  ];

    // const getFileIcon = (fileName) => {
    //     const extension = fileName.split('.').pop().toLowerCase();

    //     switch (extension) {
    //         case 'txt':
    //         return '/basic/web/images/text-plain.png';
    //         case 'pdf':
    //         return '/basic/web/images/application-pdf.png';
    //         case 'docx':
    //         return '/basic/web/images/x-office-document.png';
    //         case 'jpg':
    //         case 'jpeg':
    //         return '/basic/web/images/image-x-generic.png';
    //         case 'xls':
    //         case 'xlsx':
    //         return '/basic/web/images/x-office-spreadsheet.png';
    //         case 'csv':
    //         return '/basic/web/images/text-x-generic.png';
    //         case 'mp4':
    //         return '/basic/web/images/video-x-generic.png';
    //         case 'png':
    //         return '/basic/web/images/image-x-generic.png';
    //         default:
    //         return '/basic/web/images/image-x-generic.png';
    //     }
    // };
const getFileIcon = (fileName) => {
  if (!fileName || typeof fileName !== "string") {
    return '/basic/web/images/image-x-generic.png';
  }

  const extension = fileName.split('.').pop().toLowerCase();

  switch (extension) {
    case 'txt':
      return '/basic/web/images/text-plain.png';
    case 'pdf':
      return '/basic/web/images/application-pdf.png';
    case 'docx':
      return '/basic/web/images/x-office-document.png';
    case 'jpg':
    case 'jpeg':
      return '/basic/web/images/image-x-generic.png';
    case 'xls':
    case 'xlsx':
      return '/basic/web/images/x-office-spreadsheet.png';
    case 'csv':
      return '/basic/web/images/text-x-generic.png';
    case 'mp4':
      return '/basic/web/images/video-x-generic.png';
    case 'png':
      return '/basic/web/images/image-x-generic.png';
    default:
      return '/basic/web/images/image-x-generic.png';
  }
};

  const handleChange = (e) => {
      const { name, value } = e.target;

      if (name === "field_scout_report_sport") {
          setSelectedSport(value);  
      }

      setFormData(prev => ({ ...prev, [name]: value }));
  };

    // Handle file change
    // const handleTempFileChange = (e) => {
    //   const file = e.target.files[0];
      
    //    const maxSize = 128 * 1024 * 1024; // 128 MB
    //     if (file.size > maxSize) {
    //       errors.push('File must be less than 128 MB.');
    //     }

    //   if (file) {
    //     setTempFile(file); // Store the file temporarily
    //   }
    // };
    // Handle file change
    const handleTempFileChange = (e) => {
      const file = e.target.files[0];

      if (file) {
        setTempFile(file); // Store the file temporarily
      }
      const allowedFileTypes = ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'txt', 'wps', 'jpg', 'png', 'gif', 'html'];
      const fileExtension = file.name.split('.').pop().toLowerCase();

      if (!allowedFileTypes.includes(fileExtension)) {
        const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded. Only files with the following extensions are allowed: <em>${allowedFileTypes.join(', ')}</em>`;
        setFileUploadError(errorHTML);
        e.target.value = '';
        setTempFile(null);
        return;
      }

    setFileUploadError(''); // clear error if valid
    setTempFile(file);

    };

    // Confirm upload
    const handleUploadClick = () => {

        
      if (tempFile) {
        setSelectedFile(tempFile); // Set the selected file
        setFormData(prev => ({
          ...prev,
         field_file_upload: tempFile.name, // Store just the file name
        }));
      }
    };

// Remove file
const removeFile = () => {
  setSelectedFile(null);
  setUploadedFile(null);
  setTempFile(null);
  setFormData(prev => ({
    ...prev,
    field_file_upload: "",
    field_delete_file: 1,
  }));
};

const handleTempImageChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
  const maxSize = 128 * 1024 * 1024; // 128 MB
  const errors = [];

  if (!validTypes.includes(file.type)) {
    errors.push('Allowed file types: png, gif, jpg, jpeg.');
  }

  if (file.size > maxSize) {
    errors.push('File must be less than 128 MB.');
  }

  if (errors.length > 0) {
    const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded. Only files with the following extensions are allowed: <em>png, gif, jpg, jpeg</em>`;
    setImageUploadError(errorHTML);
    e.target.value = '';
    setTempImage(null);
    return;
  }
  setImageUploadError('');
  // Save only the FILE (temporary)
  setTempImage({ file });
};

const handleImageUploadClick = () => {
  if (tempImage?.file) {

    // Create preview ONLY after clicking Upload
    const objectUrl = URL.createObjectURL(tempImage.file);

    setSelectedImage({
      file: tempImage.file,
      preview: objectUrl
    });

    setFormData(prev => ({
      ...prev,
      field_scout_report_image: tempImage.file,
      field_delete_scout_report_image: 0
    }));

    setImageUploadError('');
  }
};


const getImageSrc = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value; // already a URL from backend
  if (value.preview) return value.preview; // wrapper object { file, preview, name }
  if (value.file && value.file instanceof File) return URL.createObjectURL(value.file); // has file
  if (value instanceof File) return URL.createObjectURL(value); // plain File object
  return "";
};

const getFileName = (value) => {
  if (!value) return "";
  if (typeof value === "string") {
    return value.split("/").pop(); // extract filename from URL
  }
  if (value.name) return value.name; // File object or wrapper with .name
  if (value.file && value.file.name) return value.file.name; // wrapper {file, preview, name}
  return "";
};


// // Remove image
// const removeImage = () => {
//   setSelectedImage(null);
//   setTempImage(null);
//   setFormData(prev => ({
//     ...prev,
//     field_scout_report_image: "",
//     field_delete_scout_report_image: 1,
//   }));
// };
 // Remove saved image handler
  const handleRemoveSavedImage = () => {
    setFormData(prev => ({
      ...prev,
      field_delete_scout_report_image: 1,
      field_scout_report_image: ''
    }));
    setSelectedImage(null);
    setTempImage(null);
    setImageUploadError('');
  };

const handleRemoveSelectedImage = () => {
  setSelectedImage(null);
  setTempImage(null);
  setImageUploadError('');
  setFormData(prev => ({
    ...prev,
    field_scout_report_image: '', //  CLEAR IT
    field_delete_scout_report_image: 1,
  }));
};

 const formatFileSize = (size) => {
    if (size < 1024) return size + " Bytes";
    else if (size < 1024 * 1024) return (size / 1024).toFixed(2) + " KB";
    else return (size / (1024 * 1024)).toFixed(2) + " MB";
  };

const handlePreviewClick = () => {
  console.log("Preview clicked");
  setViewChanges(false);
  const {
    title,
    field_file_upload,
    field_scout_report_image,
    field_scout_report_sport,
    field_meta_title,
    field_meta_keywords,
    field_meta_description,
  } = formData;


  const newErrors = {};
  if (!title.trim()) {
    newErrors.title = "Title field is required.";
  }
   if (!selectedFile && !formData.field_file_upload && !uploadedFile) {
  newErrors.field_file_upload = "File is required.";
}
  if (!field_scout_report_sport.trim()) {
    newErrors.field_scout_report_sport = "Sport field is required.";
  }
  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    setPreviewFields(false);
    return;
  }
 

  setPreviewData({
    title,
    field_file_upload,
    field_scout_report_image,
    field_scout_report_sport,
    field_meta_title,
    field_meta_keywords,
    field_meta_description,
  });
  window.scrollTo(0, 0);
  setErrors({});
  setPreviewFields(true);  
};
const handleViewChangesClick = () => {
  console.log("view clicked");
  setPreviewFields(false);
  const newErrors = {};

  if (!formData.title.trim()) {
    newErrors.title = 'Title field is required.';
  }
   if (!selectedFile && !formData.field_file_upload && !uploadedFile) {
  newErrors.field_file_upload = "File is required.";
}
  if (!formData.field_scout_report_sport.trim()) {
    newErrors.field_scout_report_sport = "Sport field is required.";
  }
  

  setErrors(newErrors);

  //  Don't return immediately, just stop enabling view changes
  if (Object.keys(newErrors).length > 0) {
    setViewChanges(false);
  } else {
    setViewChanges(true);
    // setOriginalData(savedData);
    setFormDataSnapshot(formData);
    window.scrollTo(0, 0);
  }
};


const validateForm = () => {
  const newErrors = {};

  if (!formData.title.trim()) {
    newErrors.title = 'Title field is required.';
  }
  // if (!formData.field_file_upload) {
  //   newErrors.field_file_upload = "File is required.";
  // }
  if (!selectedFile && !formData.field_file_upload && !uploadedFile) {
  newErrors.field_file_upload = "File is required.";
}

  if (!formData.field_scout_report_sport) {
    newErrors.field_scout_report_sport = "Sport field is required.";
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

 const inputStyle = {
  title: {
    border: errors.title ? '2px solid red' : '1px solid #777'
  },
 
 };
  const handleSubmit = async (e) => {
        e.preventDefault();
        setPreviewFields(false);
        setViewChanges(false);
        
        setFileUploadError('');
        setImageUploadError('');
        // setSelectedImage(null);
        // setTempImage(null);
        setDisabled(true);
        setButtonText("Saving...");
        const postData = new FormData();
         if (selectedImage && selectedImage.file) {
           postData.append('field_scout_report_image', selectedImage.file);
        }

        // Append document file
        if (selectedFile) {
          postData.append('scout_report_file', selectedFile);
        }

        // Append the rest of the form fields as JSON
        const { field_scout_report_image, ...rest } = formData; // remove image from formData
        postData.append('formData', JSON.stringify(rest));
       
         if (validateForm()) {
            const response = await fetch(app_url+'smwwscout/putscoutreport', {
            method: 'POST',
            body: postData,
        
        });
            const data = await response.json();
             if(data.data.msg == "Success") {
              setButtonText("Save");
              setDisabled(false);
                 navigate('/scout-report/'+rid+'/view', { state: { message: data.data.result } });
            } 
           
        }
    };

    
const handleDelete = async () => {
  const confirmed = window.confirm("Are you sure you want to delete?");
        if (confirmed) {
         const response = await fetch(
        app_url+'smwwscout/deletescoutreport?id='+rid,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )
        const responsedata = await response.json();
        if(responsedata.data.msg == "Success") {
          // if(domainName === configData.RSMWW_DOMAIN){
          {(userloggedinroles.includes(configData.ROLE_ADMINISTRATOR) || userloggedinroles.includes(configData.ROLE_SAADMIN)) ? (
            navigate('/manage-scouting-reports', { state: { message: responsedata.data.result } })
          ) : (
            navigate('/my_reports', { state: { message: responsedata.data.result } })
          )}
           
        }
		 
        }
};
const imageValue = selectedImage ? selectedImage.file : formData.field_scout_report_image;
let fileName = "";

if (imageValue instanceof File) {
  fileName = imageValue.name;
} else if (imageValue && typeof imageValue === "object" && imageValue.name) {
  fileName = imageValue.name;
} else if (typeof imageValue === "string") {
  fileName = imageValue.split("/").pop();
}
   
    return(
        <>
         {isLoading ? (
              <Loading />
            ) : (
        <div id="main">
                  <Helmet>
                      <title>{getPageTitle()}</title>
                  </Helmet>
            <div className="left"></div>
            <div className="center left-center">
                                {Object.values(errors).some(msg => !!msg) && (
                                  <div
                                    className="set-message-error error-message-padding"
                                    style={{
                                      background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                    }}
                                  >
                                    <ul>
                                      {Object.values(errors)
                                        .filter(msg => !!msg)
                                        .map((msg, index) => (
                                          <li key={index}>{msg}</li>
                                        ))}
                                    </ul>
                                  </div>
                                )}
                    {toggle === 2 && (
                    <>
                        
                    </>
                )}
                <>
                      <ul className="tabs primarya">
                        <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}><a>View</a></li>
                        
                        <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}><a>Edit</a></li>
                       
                      </ul></>
                      <div  className= {toggle === 1? "show-content" : "content"}>
                           <ManageScoutingReportsView />
                        </div>
                        <div  className= {toggle === 2? "show-content" : "content"}>
                <div className="managescouting-reports-edit-container">
                  {viewChanges && (
                  <div className='diff-table-wrapper'>
                    <table className="diff-table">
                    <colgroup>
                      <col className="diff-marker" />
                      <col className="diff-content" />
                      <col className="diff-marker" />
                      <col className="diff-content" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th colSpan="2">Original</th>
                        <th colSpan="2">Changes</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!formDataSnapshot || !originalData ? (
                        <tr className="no-changes">
                          <td className="diff-section-title" colSpan="4">No visible changes</td>
                        </tr>
                      ) : (
                        (() => {
                          const diffs = [];

                      
                          const compareField = (label, oldValue = '', newValue = '') => {
                            if (oldValue === newValue) return null;

                            const oldLines = (oldValue ?? '').split('\n');
                            const newLines = (newValue ?? '').split('\n');
                            const maxLines = Math.max(oldLines.length, newLines.length);

                            const rows = [
                              <tr className="diff-section-title" key={`${label}-title`}>
                                <td colSpan="4">Changes to <em>{label}</em></td>
                              </tr>
                            ];

                            for (let i = 0; i < maxLines; i++) {
                              const oldLine = (oldLines[i] || '').trim();
                              const newLine = (newLines[i] || '').trim();

                              if (oldLine !== newLine) {
                              const oldWords = oldLine.split(/\s+/);
                              const newWords = newLine.split(/\s+/);
                              const maxWords = Math.max(oldWords.length, newWords.length);

                              const renderWords = (wordsA, wordsB, isOld) =>
                                wordsA.map((word, idx) => {
                                  const matchingWord = wordsB[idx] || '';
                                  const changed = word !== matchingWord;

                                  return (
                                    <span
                                      key={`${label}-${isOld ? 'old' : 'new'}-${i}-${idx}`}
                                      style={changed ? {
                                        color: isOld ? 'red' : 'red',
                                        borderRadius: '4px',
                                        padding: '0 3px',
                                        fontWeight:'bold'
                                      } : {}}
                                    >
                                      {word}
                                      {' '}
                                    </span>
                                  );
                                });

                        rows.push(
                          <tr key={`${label}-${i}`}>
                            <td style={{width:"2px"}}><span>-</span></td>
                            <td className="diff-removed">{renderWords(oldWords, newWords, true)}</td>
                            <td style={{width:"2px"}}><span>+</span></td>
                            <td className="diff-added">{renderWords(newWords, oldWords, false)}</td>
                          </tr>
                        );
                      }
                    }

                    return rows;
                  };


                          diffs.push(...(compareField('Subject', originalData.title, formDataSnapshot.title) || []));     
                          diffs.push(...(compareField('File to Upload', originalData.field_file_upload, formDataSnapshot.field_file_upload) || []));


                  if (originalData.field_scout_report_image !== formDataSnapshot.field_scout_report_image) {
                    diffs.push(
                      <tr className="diff-section-title" key="image-title">
                        <td colSpan="4">Changes to <em>Image to Upload</em></td>
                      </tr>,
                      <tr key="image-diff">
                        <td style={{width:"2px"}}><span>-</span></td>
                        <td className="diff-removed">
                          <span>{originalData.field_scout_report_image && getFileName(originalData.field_scout_report_image)}</span>
                        </td>
                        <td style={{width:"2px"}}><span>+</span></td>
                        <td style={{color:"red",fontWeight:"bold"}} className="diff-added">
                          <span>{formDataSnapshot.field_scout_report_image && getFileName(formDataSnapshot.field_scout_report_image)}</span>
                        </td>
                      </tr>
                    );
                  }
                          diffs.push(...(compareField('Sport', originalData.field_scout_report_sport, formDataSnapshot.field_scout_report_sport) || []));
                          //  {(userloggedinroles.includes(configData.ROLE_ADMINISTRATOR) || userloggedinroles.includes(configData.ROLE_SAADMIN)) && (
                            // <>
                          diffs.push(...(compareField('Meta Title', originalData.field_meta_title, formDataSnapshot.field_meta_title) || []));
                          diffs.push(...(compareField('Meta Keywords', originalData.field_meta_keywords, formDataSnapshot.field_meta_keywords) || []));
                          diffs.push(...(compareField('Meta Description', originalData.field_meta_description, formDataSnapshot.field_meta_description) || []));
                           {/* </> */}
                          //  )}
                        
                      
                      

                          return diffs.length > 0 ? diffs : (
                            <tr className="no-changes">
                              <td className="diff-section-title" colSpan="4">No visible changes</td>
                            </tr>
                          );
                        })()
                      )}
                    </tbody>
                  </table>
                  </div>
                  )}
                    {PreviewFields && (
                      <>
                        {/* <div
                          className="messages status"
                          style={{
                            background: `#f0f8eb url("/images/message-ok.png") no-repeat`,
                            backgroundPosition: '10px 10px',
                          }}
                        >
                          The trimmed version of your post shows what your post looks like when promoted
                          to the main page or when exported for syndication.
                          <span>
                            You can insert the delimiter &lt;!--break--&gt; (without the quotes) to
                            fine-tune where your post gets split.
                          </span>
                        </div> */}

                        <div className="preview-container">
                          {/* Trimmed version */}
                          <div className="preview-trimmed">
                            <h4 className="preview-heading">
                              <span className="preview-square"></span> Preview trimmed version
                            </h4>

                            <div className="email-teaser">
                              <h2 className="email-title">
                                <a href="/full-email-page">{previewData?.title}</a>
                              </h2>

                            

                              <div className="read-more-link">
                                <a href={"/scout-report/"+rid+"/view"}>Read more</a>
                              </div>
                            </div>
                          </div>

                          {/* Full version */}
                          <div className="preview-full">
                            <h4 className="preview-heading">
                              <span className="preview-square"></span> Preview full version
                            </h4>

                            <div className="email-teaser">
                              <h2 className="email-title">
                                {/* <strong>Body:</strong> */}
                              </h2>

                                  <div className="email-meta">
                                    {previewData.field_file_upload && (
                                      <p><strong>File to Upload:</strong> {previewData.field_file_upload}</p>)}
                                    {previewData.field_scout_report_image && (
                                      <div>
                                        <strong>Image to Upload:</strong><br />
                                        <img 
                                          src={getImageSrc(previewData.field_scout_report_image)} 
                                          alt="Preview" 
                                          style={{ height: "100px", width: "100px", marginTop: "5px" }} 
                                        />
                                      </div>
                                    )}
                                     {previewData.field_scout_report_sport && (
                                    <p><strong>Sport:</strong> {previewData.field_scout_report_sport}</p>
                                    )}
                                     {/* {(userloggedinroles.includes(configData.ROLE_ADMINISTRATOR) || userloggedinroles.includes(configData.ROLE_SAADMIN)) && (
                                      <> */}
                                    {previewData.field_meta_title && (
                                    <p><strong>Meta Title:</strong> {previewData.field_meta_title}</p>
                                    )}
                                    {previewData.field_meta_keywords && (
                                    <p><strong>Meta Keywords:</strong> {previewData.field_meta_keywords}</p>
                                    )}
                                    {previewData.field_meta_description && (
                                    <p><strong>Meta Description:</strong> {previewData.field_meta_description}</p> 
                                    )} 
                                    {/* </>
                                     )} */}
                                  </div>

                                {/* </div> */}
                              {/* </div> */}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    <form onSubmit={handleSubmit}>
                      <div className="form-item field-title">
                          <label htmlFor="edit-title">
                          Title <span className="form-required" title="This field is required.">*</span>
                          </label>
                          <input
                            type="text"
                            id="edit-title"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            size="60"
                            maxLength="255"
                            className="form-text required" 
                            style={inputStyle.title}                       
                          />
                      </div>
                      <div>
                        <label>File to Upload <span className="form-required" title="This field is required.">*</span></label>
                        {fileUploadError && (
                          <div
                            className="set-message-error error-message-padding"
                            style={{
                              background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                            }}
                          >
                            <div 
                              style={{ color: '#8c2e0b',                                
                                backgroundColor: '#fef5f1',                                 
                                marginBottom: '10px', 
                                width: '80%',
                                borderRadius: '5px',
                                marginLeft:'30px'                                 
                              }}
                              dangerouslySetInnerHTML={{ __html: fileUploadError }}
                              >                           
                            </div>
                          </div>
                        )}
                        {selectedFile ? (
                          // Case 2: User just selected a new file
                          <div className="edit-scout-report-file-container">
                            <span className="file">
                              <img
                                className="file-icon"
                                alt="File icon"
                                src={getFileIcon(selectedFile.name)}
                                width="16"
                                height="16"
                              />
                              <a
                                href={URL.createObjectURL(selectedFile)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="file-name-link"
                                onClick={(e) => {
                                  e.preventDefault();
                                  const fileUrl = selectedFile 
                                  ? URL.createObjectURL(selectedFile) 
                                  : getFullFileUrl(formData.field_file_upload);
                                  window.open(fileUrl, "_blank"); 
                                }}
                              >
                                {selectedFile.name}
                              </a>
                              <span className="file-size">
                                ({formatFileSize(selectedFile.size)})
                              </span>
                            </span>
                          </div>
                        ) : formData.field_file_upload ? (
                          // Case 1: File already saved in backend
                          <div className="edit-scout-report-file-container">
                            <span className="file">
                              <img
                                className="file-icon"
                                alt="File icon"
                                src={getFileIcon(formData.field_file_upload)}
                              />
                              <a
                                href={formData.field_file_upload}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="file-name-link"
                                onClick={(e) => {
                                  e.preventDefault();
                                  const fileUrl = selectedFile 
                                  ? URL.createObjectURL(selectedFile) 
                                  : getFullFileUrl(formData.field_file_upload);
                                  window.open(fileUrl, "_blank"); 
                                }}
                              >
                                {formData.field_file_upload}
                              </a>
                            </span>
                            <span className="file-size">
                              ({formatFileSize(uploadedFile?.size)})
                            </span>
                          </div>
                        ) : uploadedFile ? (
                            <div className="edit-scout-report-file-container">
                            <span className="file">
                              <img
                                className="file-icon"
                                alt="File icon"
                                src={getFileIcon(uploadedFile.name)}
                                width="24"
                                height="24"
                              />
                              <a
                                href={uploadedFile.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="file-name-link"
                               

                              >
                                {uploadedFile.name}
                              </a>
                              <span className="file-size">
                                ({formatFileSize(uploadedFile.size)})
                              </span>
                            </span>
                          </div>
                        ) : (
                          // Case 3: No file yet → show input + custom upload button
                          <div>
                            <input
                              type="file"
                              id="edit-scout-report-file-upload"
                              name="field_file_upload"
                              onChange={handleTempFileChange}
                              style={inputStyle.field_file_upload}
                            />
                            <input
                              type="button"
                              value="Upload"
                              className="form-submit"
                              onClick={handleUploadClick}
                            />
                          </div>
                        )}
                        {(selectedFile || formData.field_file_upload || uploadedFile) && (
                        <input
                          type="button"
                          value="Remove"
                          className="form-submit"
                          onClick={removeFile}
                        />
                        )}
                        {!formData.field_file_upload && !selectedFile && (
                        <div className="description">
                            Files must be less than <b>128 MB</b>.<br />
                            Allowed file types: <b>doc docx xls xlsx pdf txt wps jpg png gif html</b>.
                          </div>
                        )}
                      </div>

                      <div>
                        {imageUploadError && (
                          <div 
                            className="set-message-error error-message-padding"
                            style={{
                              background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                            }}
                            >
                              <div 
                              style={{ color: '#8c2e0b',                                
                                backgroundColor: '#fef5f1',                                 
                                marginBottom: '10px', 
                                width: '80%',
                                borderRadius: '5px',
                                marginLeft:'30px'                                 
                              }}
                            dangerouslySetInnerHTML={{ __html: imageUploadError }}
                          >                            
                          </div>
                          </div>
                        )}
                        <div>
                          <label>Image to Upload</label>
                          {selectedImage ? (
                            // Case 1: New image selected
                            <>
                              <div className="edit-agent-image-container">
                                <img alt="Uploaded" src={selectedImage.preview} width="90" height="100" style={{marginBottom: "2px"}} />
                                <div className="image-info">
                                  <img
                                  className="file-icon"
                                  alt="File icon"
                                  src={getFileIcon(fileName)}
                                />
                                  <a
                                    href={selectedImage.preview}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="image-name-link"
                                  >
                                    {fileName}
                                  </a>
                                  <span className="image-size">
                                    ({(selectedImage.file.size / 1024).toFixed(2)} KB)
                                  </span>
                                </div>
                              </div>
                              <input
                                type="button"
                                value="Remove"
                                className="form-submit"
                                onClick={handleRemoveSelectedImage}
                              />
                            </>
                          ) : formData.field_scout_report_image ? (
                            // Case 2: Image already saved (URL string from backend)
                            <>
                              <div className="edit-scout-report-image-container">
                                <img
                                  alt="Uploaded"
                                  src={formData.field_scout_report_image}
                                  width="90"
                                  height="100"
                                  style={{marginBottom: "2px"}}
                                />
                                <div className="image-info">
                                <img
                                  className="file-icon"
                                  alt="File icon"
                                  src={getFileIcon(formData.field_scout_report_image)}
                                  width="16"
                                  height="16"
                                />
                                  <a
                                    href={formData.field_scout_report_image}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="image-name-link"
                                  >
                                    {fileName}
                                  </a>
                                  <span className="image-size">
                                    ({(uploadedImage.size / 1024).toFixed(2)} KB)
                                  </span>
                                </div>
                              </div>
                              <input
                                type="button"
                                value="Remove"
                                className="form-submit"
                                onClick={handleRemoveSavedImage}
                              />
                            </>
                          ) : (
                            // Case 3: No image yet → show upload input
                            <div>
                              <input
                                type="file"
                                id="edit-agent-photo-upload"
                                name="edit_agent_photo_upload"
                                accept="image/*"
                                onChange={handleTempImageChange}
                              />
                              <input
                                type="button"
                                value="Upload"
                                className="form-submit"
                                // onClick={() =>
                                //   document.getElementById("edit-agent-photo-upload").click()
                                // }
                                onClick={handleImageUploadClick}
                              />
                            </div>
                          )}

                          {/* {(selectedImage || formData.field_scout_report_image) && (
                            <input
                              type="button"
                              value="Remove"
                              className="form-submit"
                              onClick={removeImage}
                            />
                          )} */}

                          {!formData.field_scout_report_image && !selectedImage && (
                            <div className="description">
                              Files must be less than <b>128 MB</b>.<br />
                              Allowed file types: <b>png gif jpg jpeg</b>.
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="form-item field-scout-report-sport">
                        <label htmlFor="edit-field-scout-report-sport">
                          Sport <span className="form-required" title="This field is required.">*</span>
                        </label>     
                        <select
                          id="edit-field-scout-report-sport"
                          name="field_scout_report_sport"
                          value={formData.field_scout_report_sport}  
                          onChange={handleChange}
                        >
                          {sportsOptions.map((sport) => (
                            <option key={sport} value={sport}>
                              {sport}
                            </option>
                          ))}
                        </select>
                      </div>
                    {(userloggedinroles.includes(configData.ROLE_ADMINISTRATOR) || userloggedinroles.includes(configData.ROLE_SAADMIN)) && (
                      <>
                      <div className="form-item -field-meta-title">
                        <label htmlFor="meta_title">Meta Title</label>
                        <input className='' type="text" id="meta_title" name="field_meta_title" value={formData.field_meta_title} 
                        onChange={handleChange}  
                      /> 
                      </div>
                      <div className="form-item field-meta-keywords">
                          <label htmlFor="meta_keywords">Meta Keywords</label>
                          <input className='' type="text" id="meta_keywords" name="field_meta_keywords" value={formData.field_meta_keywords} 
                            onChange={handleChange}
                          /> 
                      </div>
                      <div className="form-item  fieldmeta-description">
                        <label>Meta Description</label>
                        <textarea
                          name="field_meta_description"
                          value={formData.field_meta_description}
                          onChange={handleChange}
                          
                        />
                        <div className="grippie" style={{
                          background: `#eee url(${process.env.PUBLIC_URL}/images/grippie.png) no-repeat center 2px`,
                        }}>   
                        </div>

                      </div></>
                    )}
                      <div>
                        {(userloggedinroles.includes(configData.ROLE_ADMINISTRATOR) || userloggedinroles.includes(configData.ROLE_SAADMIN)) && (
                        <>
                        <input 
                          type="button" 
                          id="edit-preview"  
                          value="Preview" 
                          className="form-submit" 
                          onClick={()=> {
                          handlePreviewClick();
                          // window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}
                        />&nbsp;&nbsp;
                        </>
                      )}
                        <input
                          type="button"
                          id="edit-task-preview-changes"
                          value="View changes"
                          className="form-submit"
                          onClick={handleViewChangesClick}
                        />&nbsp;&nbsp;
                        <input type="button" className="form-submit" value="Delete" onClick={handleDelete}
                        />&nbsp;&nbsp;
                        {/* <input type="submit" className="form-submit" value="Save"/> */}
                        <button type="submit" className="form-submit" disabled={disabled}>{buttontext}</button>&nbsp;&nbsp;
                      </div>
                    </form>
               </div>
               </div>
            </div>
            <div className="right">
               {domainName === configData.RSMWW_DOMAIN && 
                <SalespersonSidebar/>
              }
              {domainName === configData.RSMWW_SCOUT_DOMAIN && 
                <ScoutSidebar/>
              }
            </div>
        </div>
            )}
            </>
    );
};
export default ManageScoutingReportsEdit;